<template>
  <v-container fluid class="l-center l-base">
    <v-card style="max-width: 500px; width: 500px;" class="l-card">
      <v-card-title style="display: block; padding-bottom: 0;" class="crd-title">{{titleForm}}</v-card-title>
      <v-card-title style="display: block; padding-top: 0;" class="title-device-form" tag="p">{{title}}</v-card-title>
      <v-card-text style="margin-top: 10px;">
        <slot></slot>
      </v-card-text>
      <div class="alert-wrapper" v-if="error != ''">
        <v-alert dense outlined type="error">
          <strong>{{error}}</strong>
        </v-alert>
      </div>
      <v-card-text class="device-form-footer">
        <v-btn elevation="2" rounded @click="$emit('close')">Cancel</v-btn>
        <v-btn elevation="2" :loading="loading" rounded class="c-btn-primary " data-123 @click="$emit('action')">{{ btnTitle }}</v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
    props:{
    isEdit:{
      default: false
    },
    title:{},
    titleForm:{}, 
    btnTitle:{},
    error:{
      default: ''
    },
    loading: {
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.device-form-layout {
  position: fixed;
  width: 100vw;
  background: transparent;
  z-index: 10;
  padding-top: 30px;
  display: flex;
  left: 0;
  top: 0;
  justify-content: center;
}
.title-device-form{
    font-size: 14px !important;
    font-weight: 400;
    opacity: 0.7;
    line-height: 1;
}
.device-form-footer{
    display: flex;
    justify-content: flex-end;
    gap: 0 15px;
}
</style>